import styled, { css } from 'styled-components';
import Colors from 'constants/Colors';

/* export const Content = styled.div`
  background: ${Colors.WHITE};
  margin-top: 40px;
  border: 1px solid #6bcbba;
  background: #fff;
  margin-bottom: 40px;
  border-radius: 20px;
  box-shadow: 0px 17px 17px 6px #5f5f5f1a;
`; */
export const Content = styled.div`
  //background: ${Colors.WHITE};
  background:transparent;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 1vh;
`;

export const CalendarContainer = styled.div`
  z-index: 55;
  top: 60px;
  right: 24px;

  position: absolute;
`;

export const ButtonContainer = styled.div`
display: flex;
flex-direction:row;
justify-content:space-between;
align-items:center;

width: 100%;
padding: 0px 0px 0px 0px;
`;
export const AceptContainer = styled.div`
display: flex;
flex-direction:row;
justify-content:flex-end;
align-items:center;

width: 100%;
padding: 0px 0px 0px 0px;
`;

export const Fieldset = styled.fieldset`
  border: none;
  /* padding: 0px;
   & + Fieldset{
    border:solid ;
    border-color: ${Colors.GRAY[4]};
    border-width: 2px 0px 0px 0px;
   } */
`;

export const Line = styled.div`
    width: 100%;
    margin: 10px 10px;
    height: 2px;
    background-color: ${Colors.GRAY[4]};
`;

export const Logo = styled.img`
  display:block;
  width:90%;
  height:auto;
  margin-left: auto;
  margin-right: auto;
`;

export const CardInfo = styled.div`
 
    ${(props) => props.card ? css`
    max-height: 400px;
    overflow:hidden;
    transition: max-height .6s linear;`
    :
    css`
    max-height: 0px;
    padding: 0px;
    transition: max-height .6s linear;    
    overflow:hidden;`
  };
`;